<section class="page">
  <h1>Inscription</h1>
  <p class="subtitle">Créez votre compte pour rejoindre CoffeeClub.</p>
  <form class="card" (ngSubmit)="submit()">
    <div class="field-row">
      <label class="field">
        <span>Prénom</span>
        <input [(ngModel)]="firstName" type="text" placeholder="Marie" name="firstName" />
      </label>
      <label class="field">
        <span>Nom</span>
        <input [(ngModel)]="lastName" type="text" placeholder="Dupont" name="lastName" />
      </label>
    </div>
    <label class="field">
      <span>Email</span>
      <input [(ngModel)]="email" type="email" placeholder="nom@exemple.be" name="email" />
    </label>
    <label class="field">
      <span>Mot de passe</span>
      <input [(ngModel)]="password" type="password" placeholder="••••••••" name="password" />
    </label>
    <label class="field">
      <span>Confirmation du mot de passe</span>
      <input
        [(ngModel)]="confirmPassword"
        type="password"
        placeholder="••••••••"
        name="confirmPassword"
      />
    </label>
    <label class="field">
      <span>Plateau</span>
      <select [(ngModel)]="plateauId" name="plateauId" [disabled]="isLoadingPlateaux">
        <option [ngValue]="null">Sélectionner un plateau</option>
        <option *ngFor="let plateau of plateaux" [ngValue]="plateau.id">
          {{ plateau.name }}
        </option>
      </select>
    </label>
    <button class="primary" type="submit" [disabled]="isLoading">
      {{ isLoading ? 'Envoi...' : 'Créer mon compte' }}
    </button>
    <p class="hint" *ngIf="isLoadingPlateaux">Chargement des plateaux...</p>
    <p class="success" *ngIf="message">{{ message }}</p>
    <p class="error" *ngIf="errorMessage">{{ errorMessage }}</p>
    <a class="link" routerLink="/login">Déjà un compte ? Se connecter</a>
  </form>
</section>
